import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=75b4e1cb&scoped=true&"
import script from "./Gift.vue?vue&type=script&lang=ts&"
export * from "./Gift.vue?vue&type=script&lang=ts&"
import style0 from "./Gift.vue?vue&type=style&index=0&id=75b4e1cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b4e1cb",
  null
  
)

export default component.exports